// import Swiper JS
import Swiper from "swiper";
import { Autoplay, FreeMode } from "swiper/modules";
// import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/autoplay";

document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".swiper-2", {
    loop: true,
    slidesPerView: 3,
    grabCursor: true,
    centeredSlides: true,
    modules: [Autoplay, FreeMode],
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 3500,
    breakpoints: {
      991: {
        slidesPerView: 8,
      },
    },
  });
});

